import { render, staticRenderFns } from "./UploadShipmentsModal.vue?vue&type=template&id=10ba357c"
import script from "./UploadShipmentsModal.vue?vue&type=script&lang=js"
export * from "./UploadShipmentsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadShipmentsModal.vue?vue&type=style&index=0&id=10ba357c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports